const VALID_BOOLEAN_IS_TRUE_VALUES = [true, "true", "yes", "tak", "kyllä"];

export const formatBoolean = async (booleanValue) => {
  if(VALID_BOOLEAN_IS_TRUE_VALUES.includes(booleanValue.toString().trim().toLowerCase())) {
    return true;
  }
  return false;
}